import React, { useMemo } from 'react';
import { Retailer } from '../../Types/Retailer';
import Icon from '../Icon';
import { translate } from '../../Services/translation';

interface MarkerInfoBoxProps {
  retailer: Retailer;
}

const MarkerInfoBox = ({ retailer }: MarkerInfoBoxProps) => {
  const directionsUrl = useMemo(() => {
    return `https://www.google.com/maps?saddr=My+Location&daddr=${retailer.position.lat},${retailer.position.lng}`;
  }, [retailer]);
  return (
    <div className="pr-1">
      <div className="text-md font-bold ">{retailer.name}</div>
      <div className="my-4 flex flex-col gap-2">
        {retailer.formattedAddress && (
          <div className="flex items-center gap-0.5 whitespace-nowrap">
            <Icon className="h-5 w-5 " name="map-pin-light" />
            <span className="flex flex-col text-sm text-gray-700">
              <span>{retailer.formattedAddress}</span>
            </span>
          </div>
        )}
        {retailer.phoneNumber && (
          <div className="flex items-center gap-0.5 ">
            <Icon className="h-5 w-5" name="phone-light" />
            <span className="text-sm text-gray-700 underline">
              <a href={`tel:${retailer.phoneNumber}`}>
                {retailer.phoneNumber}
              </a>
            </span>
          </div>
        )}
        {retailer.email && (
          <div className="flex items-center gap-0.5 ">
            <Icon className="h-5 w-5" name="mail" />
            <span className="text-sm text-gray-700 underline">
              <a href={`mailto:${retailer.email}`}>{retailer.email}</a>
            </span>
          </div>
        )}
        {retailer.website && (
          <div className="flex items-center gap-0.5">
            <Icon className="h-5 w-5" name="link-light" />
            <span className="text-sm text-gray-700 underline">
              <a href={retailer.website}>{retailer.website}</a>
            </span>
          </div>
        )}
      </div>
      {retailer.position.lat && retailer.position.lng && (
        <a
          className="-ml-2 mt-2 p-2 underline"
          target="_blank"
          href={directionsUrl}
          rel="noreferrer"
        >
          {translate('retailers.show-directions')}
        </a>
      )}
    </div>
  );
};

export default MarkerInfoBox;
